import React, { FC } from 'react';
import { TypeConditionalBannerFields } from '@/core/generated-types';
import { BfcmCpUpsellBanner, BannerPresentation } from './components';

export interface ConditionalBannerProps extends TypeConditionalBannerFields {
  userUuid?: string | undefined;
}

const ConditionalBanner: FC<ConditionalBannerProps> = (fields) => {
  const { condition } = fields;

  switch (condition) {
    case 'bfcm cp upsell':
      return <BfcmCpUpsellBanner {...fields} />;
    case 'always visible':
    default:
      return <BannerPresentation {...fields} />;
  }
};

export default React.memo(ConditionalBanner);
